import { forwardRef, useEffect, useState } from "react";
import { getTemplateConfig } from "./PrintTemplate";


export const PrintView = forwardRef(
  (
    { template = "classic", children },
    ref,
  ) => {
    const templateConfig = getTemplateConfig(template);
    const colors = templateConfig.colors;

    const [companyInfo,setcompanyInfo] = useState({})
useEffect(()=>{
   const MasterCompanyDetails =  JSON.parse(localStorage.getItem("MasterCompanyDetails") || "");
   setcompanyInfo(MasterCompanyDetails?.[0])
},[])
const cleanNumber = (num = "") => num.replace(/[^\d\-]/g, "");

const extractContactClean = (text = "") => {
  const telMatch = text.match(/TEL\s*\(?([\d\-()\s]+)\)?/i);
  const faxMatch = text.match(/FAX\s*:\s*\(?([\d\-()\s]+)\)?/i);

  return {
    tel: telMatch ? cleanNumber(telMatch[1]) : "",
    fax: faxMatch ? cleanNumber(faxMatch[1]) : "",
  };
}
const result = extractContactClean(companyInfo?.ProfileAddressPrint);
    return (
      <div
        ref={ref}
        className="print-view bg-white font-sans p-8"
        style={{ color: colors.valueColor }}
      >
        {/* Header */}
        <div
          className="pb-5 mb-6"
          style={{ borderBottom: `3px solid ${colors.borderColor}`, marginBottom:"24px",paddingBottom:"20px" }}
        >
          <div className="flex justify-between items-start" >
            <div className="flex items-center gap-4">
              <div
                className=""
                // style={{ background: colors.headerBg }}
              >
                {/* <span
                  style={{ color: colors.headerText }}
                  className="font-bold text-lg"
                >
                  FF
                </span> */}
                <img src={companyInfo?.CompanyLogo} alt={companyInfo?.CompanyName} style={{maxWidth:"158px", height:"auto"}}/>
                <p class="text-xs text-gray-500 mb-1">Intelligent Freight Solutions</p>
              </div>
              {/* <div>
                <h1
                  className="text-xl font-bold tracking-tight"
                  style={{ color: colors.primary }}
                >
                  {companyInfo?.CompanyName}
                </h1>
                <p
                  className="text-xs mt-1"
                  style={{ color: colors.labelColor }}
                >
                  {companyInfo?.ProfileCountry}
                </p>
              </div> */}
            </div>
            <div
              className="text-right text-xs space-y-0.5"
              style={{ color: colors.labelColor }}
            >
              <p className="font-medium">{companyInfo?.ProfileAddress1}</p>
              {companyInfo?.ProfileAddress2 ?<p className="font-medium">{companyInfo?.ProfileAddress2 }</p>:""}
              <p className="font-medium">Tel:{result?.tel}</p>
              <p>Fax:{result?.fax}</p>
              <p>{companyInfo?.ProfileEmailId}</p>
              <p
                className="font-semibold mt-1"
                style={{ color: colors.primary }}
              >
                {companyInfo?.website}
              </p>
            </div>
          </div>
        </div>

        {children}

        {/* Footer */}
        <div
          className="mt-8 pt-4"
          style={{ borderTop: `2px solid ${colors.borderColor}` }}
        >
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-3">
              <div
                className="w-8 h-8 rounded-lg flex items-center justify-center"
                style={{ background: colors.headerBg }}
              >
                <span
                  className="text-xs font-bold"
                  style={{ color: colors.headerText }}
                >
                  FF
                </span>
              </div>
              <div>
                <span className="text-xs" style={{ color: colors.labelColor }}>
                  Powered by
                </span>
                <p
                  className="text-sm font-semibold"
                  style={{ color: colors.primary }}
                >
                  Shipez.ai TMS
                </p>
              </div>
            </div>
            <div
              className="flex gap-6 text-xs"
              style={{ color: colors.labelColor }}
            >
              <span>{companyInfo?.phone}</span>
              <span>{companyInfo?.email}</span>
              <span className="font-medium" style={{ color: colors.primary }}>
                {companyInfo?.website}
              </span>
            </div>
          </div>
        </div>

        {/* Print Styles */}
        <style>{`
          @media print {
            .print-view {
              padding: 20px;
              font-size: 11pt;
            }
            .print-section {
              page-break-inside: avoid;
            }
            @page {
              margin: 0.5in;
              size: letter;
            }
          }
        `}</style>
      </div>
    );
  },
);

PrintView.displayName = "PrintView";

export function PrintSection({ title, children, colors }) {
  return (
    <div className="print-section mb-5">
      <h3
        className="px-3 py-2 font-semibold text-sm uppercase tracking-wide rounded-tr rounded-br mb-3"
        style={{
          borderLeft: `4px solid ${colors.primary}`,
          background: `linear-gradient(90deg, ${colors.accent}40 0%, transparent 100%)`,
          color: colors.primary,
        }}
      >
        {title}
      </h3>
      <div className="pl-2">{children}</div>
    </div>
  );
}

export function PartyCard({ title, name, address, colors }) {
  return (
    <div
      className="p-4 rounded-lg"
      style={{
        background: `linear-gradient(135deg, ${colors.sectionBg} 0%, white 100%)`,
        border: `1px solid ${colors.tableBorderColor}`,
        boxShadow: "0 1px 4px rgba(0,0,0,0.03)",
      }}
    >
      <h4
        className="font-semibold text-xs uppercase tracking-wide mb-2 pb-1"
        style={{
          color: colors.primary,
          borderBottom: `1px dashed ${colors.tableBorderColor}`,
        }}
      >
        {title}
      </h4>
      <p className="font-semibold text-sm" style={{ color: colors.valueColor }}>
        {name || "-"}
      </p>
      <p
        className="text-xs mt-1 whitespace-pre-line"
        style={{ color: colors.labelColor }}
      >
        {address || ""}
      </p>
    </div>
  );
}

export function LabelValue({ label, value, highlight, multiline, colors }) {
  return (
    <div className="mb-3">
      <span
        className="text-xs uppercase tracking-wider font-medium block mb-0.5"
        style={{ color: colors.labelColor }}
      >
        {label}
      </span>
      <p
        className={`text-sm ${highlight ? "font-bold" : "font-medium"} ${multiline ? "whitespace-pre-line" : ""}`}
        style={{
          color: highlight ? colors.primary : colors.valueColor,
          ...(highlight && {
            background: `${colors.primary}08`,
            padding: "2px 6px",
            borderRadius: "4px",
            display: "inline-block",
          }),
        }}
      >
        {value || "-"}
      </p>
    </div>
  );
}


export function DetailCell({
  label,
  value,
  colors,
  highlight,
}) {
  return (
    <div
      style={{
        padding: "10px 14px",
        borderBottom: `1px solid ${colors.tableBorderColor}30`,
        borderLeft: `1px solid ${colors.tableBorderColor}30`,
      }}
    >
      <span
        style={{
          fontSize: 9,
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: "0.06em",
          color: colors.labelColor,
          display: "block",
          marginBottom: 2,
        }}
      >
        {label}
      </span>
      <span
        style={{
          fontSize: highlight ? 14 : 12,
          fontWeight: highlight ? 700 : 500,
          color: highlight ? colors.primary : colors.valueColor,
          fontFamily: highlight ? "monospace" : "inherit",
        }}
      >
        {value}
      </span>
    </div>
  );
}

export function RefCell({
  label,
  value,
  colors,
}) {
  return (
    <div
      style={{
        padding: "8px 12px",
        borderBottom: `1px solid ${colors.tableBorderColor}30`,
        borderRight: `1px solid ${colors.tableBorderColor}30`,
      }}
    >
      <span
        style={{
          fontSize: 9,
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: "0.06em",
          color: colors.labelColor,
          display: "block",
          marginBottom: 2,
        }}
      >
        {label}
      </span>
      <span style={{ fontSize: 12, fontWeight: 500, color: colors.valueColor }}>{value || "-"}</span>
    </div>
  );
}
